import { render, staticRenderFns } from "./TotalAssetsTable.vue?vue&type=template&id=f9823d1a"
import script from "./TotalAssetsTable.vue?vue&type=script&lang=js"
export * from "./TotalAssetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports